export const petTypeLabels = {
  cat: 'Кіт',
  dog: 'Собака',
};

export const petTypeIdMap = {
  1: 'cat',
  2: 'dog',
};
